//
// Renote Companion — plugin id package entry point.
//

import { companionId, companionPlugin } from './plugin'

export * from './types'

export { companionId }
export default companionPlugin
